import React from 'react';
import trustpilotLoader from '../../../../util/trustpilot';

class OffersV4SocialProof extends React.Component {
    constructor(props) {
        super(props);
        this.trustboxRef = React.createRef();
    }

    componentDidMount() {
        trustpilotLoader.loadScripts().then(() => {
            if (window.Trustpilot && this.trustboxRef.current) {
                window.Trustpilot.loadFromElement(this.trustboxRef.current);
            }
        });
    }

    render() {
        return (
            <div className="offers-v4-social-proof">
                <div
                    ref={this.trustboxRef}
                    className="trustpilot-widget"
                    data-locale="en-US"
                    data-template-id="53aa8807dec7e10d38f59f32"
                    data-businessunit-id="56b4baf70000ff0005888a80"
                    data-style-height="150px"
                    data-style-width="100%"
                    data-token="28622286-b4aa-45fe-bde7-fd15c147b5a4"
                >
                    <a href="https://www.trustpilot.com/review/rocketloans.com" target="_blank" rel="noopener noreferrer">Trustpilot</a>
                </div>
            </div>
        );
    }
}

export default OffersV4SocialProof;
